<template>
  <multiselect
    :placeholder="placeholder"
    style="min-width: 168px"
    :show-labels="false"
    selectLabel
    v-model="selected"
    @input="updateFilters"
    :options="options"
    track-by="value"
    label="title"
  >
    <template slot="option" slot-scope="props">
      <span>{{ props.option.title }}</span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SentimentFilter',
  components: {
    Multiselect
  },
  props: {
    sentiment: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'All'
    }
  },
  mounted() {
    if (this.sentiment) {
      this.selected = this.options.find((op) => op.value === this.sentiment)
    }
  },
  data: () => ({
    selected: null,
    options: [
      { title: 'All', value: null },
      { title: 'Negative', value: 'NEGATIVE' },
      { title: 'Positive', value: 'POSITIVE' }
    ]
  }),
  methods: {
    updateFilters(selection) {
      this.$emit('update', selection.value)
    }
  }
}
</script>
